<div class="apenas--mobile">
  <div class="container-principal__header">
    <dynamic-form [fields]="regLabelMenuCacauLover"></dynamic-form>
  </div>
</div>

<div class="apenas--desktop">
  <div class="container-principal__header header--desktop">
    <span class="fa fa-heart header__icone"></span>
    <label class="cs_label header__titulo">Desafios</label>
  </div>
</div>

<div class="desafio-detalhes">
  <div class="desafios">
    <dynamic-form [fields]="regDesafioDetalhe"></dynamic-form>
  </div>
</div>

<div class="desafio-carregando" *ngIf="carregandoDesafio">
  <app-only-loader></app-only-loader>
</div>
